/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as FormPreviewRouteImport } from './routes/form-preview'
import { Route as FormRouteImport } from './routes/form'
import { Route as KioskLocationIdRouteImport } from './routes/kiosk_.$locationId'
import { Route as LegalTermsConditionsLocationIdRouteImport } from './routes/legal.terms-conditions_.$locationId'
import { Route as LegalPrivacyPolicyLocationIdRouteImport } from './routes/legal.privacy-policy_.$locationId'
import { Route as KioskNewPatronLocationIdRouteImport } from './routes/kiosk.new-patron_.$locationId'
import { Route as KioskFormsLocationIdRouteImport } from './routes/kiosk.forms_.$locationId'
import { Route as KioskExistingPatronLocationIdRouteImport } from './routes/kiosk.existing-patron_.$locationId'

const FormPreviewRoute = FormPreviewRouteImport.update({
  id: '/form-preview',
  path: '/form-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const FormRoute = FormRouteImport.update({
  id: '/form',
  path: '/form',
  getParentRoute: () => rootRouteImport,
} as any)
const KioskLocationIdRoute = KioskLocationIdRouteImport.update({
  id: '/kiosk_/$locationId',
  path: '/kiosk/$locationId',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalTermsConditionsLocationIdRoute =
  LegalTermsConditionsLocationIdRouteImport.update({
    id: '/legal/terms-conditions_/$locationId',
    path: '/legal/terms-conditions/$locationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const LegalPrivacyPolicyLocationIdRoute =
  LegalPrivacyPolicyLocationIdRouteImport.update({
    id: '/legal/privacy-policy_/$locationId',
    path: '/legal/privacy-policy/$locationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const KioskNewPatronLocationIdRoute =
  KioskNewPatronLocationIdRouteImport.update({
    id: '/kiosk/new-patron_/$locationId',
    path: '/kiosk/new-patron/$locationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const KioskFormsLocationIdRoute = KioskFormsLocationIdRouteImport.update({
  id: '/kiosk/forms_/$locationId',
  path: '/kiosk/forms/$locationId',
  getParentRoute: () => rootRouteImport,
} as any)
const KioskExistingPatronLocationIdRoute =
  KioskExistingPatronLocationIdRouteImport.update({
    id: '/kiosk/existing-patron_/$locationId',
    path: '/kiosk/existing-patron/$locationId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/form': typeof FormRoute
  '/form-preview': typeof FormPreviewRoute
  '/kiosk/$locationId': typeof KioskLocationIdRoute
  '/kiosk/existing-patron/$locationId': typeof KioskExistingPatronLocationIdRoute
  '/kiosk/forms/$locationId': typeof KioskFormsLocationIdRoute
  '/kiosk/new-patron/$locationId': typeof KioskNewPatronLocationIdRoute
  '/legal/privacy-policy/$locationId': typeof LegalPrivacyPolicyLocationIdRoute
  '/legal/terms-conditions/$locationId': typeof LegalTermsConditionsLocationIdRoute
}
export interface FileRoutesByTo {
  '/form': typeof FormRoute
  '/form-preview': typeof FormPreviewRoute
  '/kiosk/$locationId': typeof KioskLocationIdRoute
  '/kiosk/existing-patron/$locationId': typeof KioskExistingPatronLocationIdRoute
  '/kiosk/forms/$locationId': typeof KioskFormsLocationIdRoute
  '/kiosk/new-patron/$locationId': typeof KioskNewPatronLocationIdRoute
  '/legal/privacy-policy/$locationId': typeof LegalPrivacyPolicyLocationIdRoute
  '/legal/terms-conditions/$locationId': typeof LegalTermsConditionsLocationIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/form': typeof FormRoute
  '/form-preview': typeof FormPreviewRoute
  '/kiosk_/$locationId': typeof KioskLocationIdRoute
  '/kiosk/existing-patron_/$locationId': typeof KioskExistingPatronLocationIdRoute
  '/kiosk/forms_/$locationId': typeof KioskFormsLocationIdRoute
  '/kiosk/new-patron_/$locationId': typeof KioskNewPatronLocationIdRoute
  '/legal/privacy-policy_/$locationId': typeof LegalPrivacyPolicyLocationIdRoute
  '/legal/terms-conditions_/$locationId': typeof LegalTermsConditionsLocationIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/form'
    | '/form-preview'
    | '/kiosk/$locationId'
    | '/kiosk/existing-patron/$locationId'
    | '/kiosk/forms/$locationId'
    | '/kiosk/new-patron/$locationId'
    | '/legal/privacy-policy/$locationId'
    | '/legal/terms-conditions/$locationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/form'
    | '/form-preview'
    | '/kiosk/$locationId'
    | '/kiosk/existing-patron/$locationId'
    | '/kiosk/forms/$locationId'
    | '/kiosk/new-patron/$locationId'
    | '/legal/privacy-policy/$locationId'
    | '/legal/terms-conditions/$locationId'
  id:
    | '__root__'
    | '/form'
    | '/form-preview'
    | '/kiosk_/$locationId'
    | '/kiosk/existing-patron_/$locationId'
    | '/kiosk/forms_/$locationId'
    | '/kiosk/new-patron_/$locationId'
    | '/legal/privacy-policy_/$locationId'
    | '/legal/terms-conditions_/$locationId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  FormRoute: typeof FormRoute
  FormPreviewRoute: typeof FormPreviewRoute
  KioskLocationIdRoute: typeof KioskLocationIdRoute
  KioskExistingPatronLocationIdRoute: typeof KioskExistingPatronLocationIdRoute
  KioskFormsLocationIdRoute: typeof KioskFormsLocationIdRoute
  KioskNewPatronLocationIdRoute: typeof KioskNewPatronLocationIdRoute
  LegalPrivacyPolicyLocationIdRoute: typeof LegalPrivacyPolicyLocationIdRoute
  LegalTermsConditionsLocationIdRoute: typeof LegalTermsConditionsLocationIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/form-preview': {
      id: '/form-preview'
      path: '/form-preview'
      fullPath: '/form-preview'
      preLoaderRoute: typeof FormPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/form': {
      id: '/form'
      path: '/form'
      fullPath: '/form'
      preLoaderRoute: typeof FormRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kiosk_/$locationId': {
      id: '/kiosk_/$locationId'
      path: '/kiosk/$locationId'
      fullPath: '/kiosk/$locationId'
      preLoaderRoute: typeof KioskLocationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/terms-conditions_/$locationId': {
      id: '/legal/terms-conditions_/$locationId'
      path: '/legal/terms-conditions/$locationId'
      fullPath: '/legal/terms-conditions/$locationId'
      preLoaderRoute: typeof LegalTermsConditionsLocationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/privacy-policy_/$locationId': {
      id: '/legal/privacy-policy_/$locationId'
      path: '/legal/privacy-policy/$locationId'
      fullPath: '/legal/privacy-policy/$locationId'
      preLoaderRoute: typeof LegalPrivacyPolicyLocationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kiosk/new-patron_/$locationId': {
      id: '/kiosk/new-patron_/$locationId'
      path: '/kiosk/new-patron/$locationId'
      fullPath: '/kiosk/new-patron/$locationId'
      preLoaderRoute: typeof KioskNewPatronLocationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kiosk/forms_/$locationId': {
      id: '/kiosk/forms_/$locationId'
      path: '/kiosk/forms/$locationId'
      fullPath: '/kiosk/forms/$locationId'
      preLoaderRoute: typeof KioskFormsLocationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kiosk/existing-patron_/$locationId': {
      id: '/kiosk/existing-patron_/$locationId'
      path: '/kiosk/existing-patron/$locationId'
      fullPath: '/kiosk/existing-patron/$locationId'
      preLoaderRoute: typeof KioskExistingPatronLocationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  FormRoute: FormRoute,
  FormPreviewRoute: FormPreviewRoute,
  KioskLocationIdRoute: KioskLocationIdRoute,
  KioskExistingPatronLocationIdRoute: KioskExistingPatronLocationIdRoute,
  KioskFormsLocationIdRoute: KioskFormsLocationIdRoute,
  KioskNewPatronLocationIdRoute: KioskNewPatronLocationIdRoute,
  LegalPrivacyPolicyLocationIdRoute: LegalPrivacyPolicyLocationIdRoute,
  LegalTermsConditionsLocationIdRoute: LegalTermsConditionsLocationIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
